import React from "react"

import { TResolvedTextBlocks } from "@/lib/kontent/components/getTextBlocks"

import { FeatureList } from "./FeatureList"

type TFeatureListResolverProps = {
  resolvedData: TResolvedTextBlocks
  isInArticle: boolean
}

const FeatureListResolver = ({
  resolvedData,
  isInArticle,
}: TFeatureListResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    isInArticle: isInArticle,
    features: resolvedData.textBlocks.map((block) => {
      return {
        title: block.title,
        icon: block.icon,
        text: block.body,
      }
    }),
    buttons: resolvedData.button,
  }

  return <FeatureList {...kontentData} />
}

export { FeatureListResolver, type TFeatureListResolverProps }
